import { render, staticRenderFns } from "./AddRoleModal.vue?vue&type=template&id=62f05f7f&scoped=true&"
import script from "./AddRoleModal.vue?vue&type=script&lang=js&"
export * from "./AddRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./AddRoleModal.vue?vue&type=style&index=0&id=62f05f7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f05f7f",
  null
  
)

export default component.exports